export default "__VITE_ASSET__BcfvGoPB__";